import React from 'react';
import styled from 'styled-components';
import PriceChangeWarning from './components/PriceChangeWarning';
import PriceTimer from './components/PriceTimer';
import type { PriceDirection } from './types';

type Props = {
  priceChanged: boolean;
  changeDirection?: PriceDirection;
  isPriceChangedSignificantly: boolean;
  oldPrice?: number;
  currentPrice?: number;
  lastUpdated: number;
  timeout: number;
  fetching: boolean;
  instantConfirm: boolean;
};

const PriceChecker = (props: Props) => {
  const {
    priceChanged,
    changeDirection,
    isPriceChangedSignificantly,
    oldPrice,
    currentPrice,
    lastUpdated,
    timeout,
    fetching,
    instantConfirm,
  } = props;

  return (
    <Wrapper>
      <PriceChangeWarning
        priceChanged={priceChanged}
        changeDirection={changeDirection}
        isPriceChangedSignificantly={isPriceChangedSignificantly}
        oldPrice={oldPrice}
        currentPrice={currentPrice}
      />
      <PriceTimer
        currentPrice={currentPrice}
        fetching={fetching}
        timeout={timeout}
        lastUpdated={lastUpdated}
        instantConfirm={instantConfirm}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  > * + * {
    margin-top: 8px;
  }
`;

export default PriceChecker;
